/**
 * Pozycja w rankingu do tytułu slajdu. Angielski chce liczebnika porządkowego (1st/2nd/3rd),
 * polskiemu wystarcza sama liczba („Zajmujesz 1 miejsce”). `Intl.PluralRules` w trybie `ordinal`
 * daje kategorię, z której składamy angielską końcówkę.
 *
 * Współdzielone przez slajd na ekranie (`ReportCompetitiveRanking`) i wersję PDF — obie ścieżki
 * muszą pokazać tę samą liczbę.
 */
export const formatRank = (rank: number, language: string): string => {
  if (!language.startsWith('en')) {
    return String(rank);
  }

  const suffixes: Record<string, string> = { one: 'st', two: 'nd', few: 'rd', other: 'th' };
  const category = new Intl.PluralRules('en', { type: 'ordinal' }).select(rank);
  return `${rank}${suffixes[category] ?? 'th'}`;
};
